import React, { useState } from "react";
import PropTypes from "prop-types";
import CFSelect from "../shared/forms/CFSelect";

const OPTIONS = [
  { value: "false", label: "Always show" },
  { value: "true", label: "Schedule for timeframe" },
];

const BroadcastTimeframeSelect = ({ timeframe }) => {
  const [selected, setSelected] = useState(
    OPTIONS.find((option) => option.value === (timeframe ? "true" : "false"))
  );

  function handleChange(option) {
    setSelected(option);

    const timeframeDiv = $('.campaign-step [data-type="timeframe"]');
    if (option.value === "false") {
      timeframeDiv.find(".time-selection").hide();
    } else {
      timeframeDiv.find(".time-selection").show();
    }
    timeframeDiv.find(".timeframe-submit").show();
  }

  return (
    <React.Fragment>
      <input type="hidden" name="broadcast[timeframe]" value={selected.value} />
      <CFSelect
        options={OPTIONS}
        value={selected}
        onChange={handleChange}
        isSearchable={false}
      />
    </React.Fragment>
  );
};

BroadcastTimeframeSelect.propTypes = {
  timeframe: PropTypes.bool,
};

export default BroadcastTimeframeSelect;
